export default "__VITE_ASSET__CmmaSCU3__"